(function () {
    "use strict";

    angular.module("papp").config(stateConfig);

    stateConfig.$inject = ["$stateProvider"];

    function stateConfig($stateProvider) {
        $stateProvider.state("studdedTirePrice", {
            parent: "price",
            url: "/price/studded-tire",
            data: {
                authorities: ["bilioslo-admin", "bilioslo-admin-lese"],
            },
            views: {
                "content@": {
                    templateUrl:
                        "app/price/studded-tire/studded-tire-price.html",
                    controller: "StuddedTirePriceController",
                    controllerAs: "vm",
                },
            },
        });
    }
})();
